import { render, staticRenderFns } from "./WheelBattleDetailHeader.vue?vue&type=template&id=6897835e&scoped=true&"
import script from "./WheelBattleDetailHeader.vue?vue&type=script&lang=js&"
export * from "./WheelBattleDetailHeader.vue?vue&type=script&lang=js&"
import style0 from "./WheelBattleDetailHeader.vue?vue&type=style&index=0&id=6897835e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6897835e",
  null
  
)

export default component.exports